module.exports = __webpack_public_path__ + "img/spatial.a33eef2b.png";